export const getBox = (configs, boxType) => {
  const box = Object.values(configs).find(e => e.boxType === boxType);
  return box;
};